import { DomainError, formatMoney } from "@szerviz/core";
import { useTranslation } from "react-i18next";

/** Outside services whose technical reason helps support (shown small under the message). */
const SHOW_DETAIL = new Set<string>(["AI_FAILED", "INVOICE_FAILED", "SEND_FAILED", "TAXPAYER_FAILED", "FEEDBACK_FAILED", "IMPORT_COLUMNS_MISSING"]);

/** Shows a domain error as "message + what to do", any other error with its text. */
export function ErrorText({ error }: { error: unknown }) {
  const { t, i18n } = useTranslation();
  if (!error) return null;
  if (error instanceof DomainError) {
    return (
      <p className="error" role="alert">
        <strong>{t(error.messageKey)}</strong> {t(error.actionKey)}
        {error.code === "AI_CREDIT_LOW" && /^\d+$/.test(error.detail ?? "") && (
          <small className="error-detail">{t("ai.creditNeeded", { count: Number(error.detail) })}</small>
        )}
        {SHOW_DETAIL.has(error.code) && error.detail && error.detail !== error.code && <small className="error-detail">{t("common.errorDetail", { detail: error.detail })}</small>}
      </p>
    );
  }
  const message = error instanceof Error ? error.message : String(error);
  return (
    <p className="error" role="alert">
      {t("common.error", { message })}
    </p>
  );
}
